import React from 'react';
import { styled } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { Colors } from 'library';
import { Stack } from './Stack';

const PADDED_PATH_PREFIXES = ['/adminperson/payments'];

export function AdminLayout({ children }: { children: React.ReactNode }) {
    const { pathname } = useLocation();
    const padded = PADDED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));

    return (
        <Background>
            {padded ? (
                <Centered>
                    <Stack maxWidth="xl" fullWidth gap="lg" padding="lg">
                        {children}
                    </Stack>
                </Centered>
            ) : (
                children
            )}
        </Background>
    );
}

const Background = styled('div')({
    backgroundColor: Colors.surface,
    flex: 1,
    minHeight: 0,
});

const Centered = styled('div')({
    display: 'flex',
    justifyContent: 'center',
});
